import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function Samosas() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Samosas</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 cups (250 g)
        all-purpose flour<br></br>1 tsp salt<br></br>⅓ cup (100 ml) + 1 tbsp
        cold water<br></br>4 tbsp vegetable oil<br></br>
        <b>Filling:</b>
        <br></br>
        10.5 oz (300 g) russet potatoes peeled and diced<br></br>1 tbsp oil for
        frying<br></br>1 onion chopped<br></br>2 garlic cloves minced<br></br>2
        tsp ginger grated<br></br>1 tbsp curry powder I used garam masala
        <br></br>1 tsp cumin ground<br></br>1 tsp paprika powder or chili powder
        to taste<br></br>1 tsp turmeric optional<br></br>½ cup (80 g) peas
        frozen and thawed<br></br>½ (80 g) red bell pepper or green peppers,
        finely chopped<br></br>1 tsp salt or to taste<br></br>
        black pepper to taste<br></br>
        <b>For frying (or bake them, *see notes)</b>
        <br></br>2 cups (480 ml) of vegetable oil<br></br>
      </Typography>

      <Typography>
        <b>Dough:</b>
        <br></br>
        Whisk the flour and salt together in a bowl.<br></br>
        Pour in the cold water and oil, then mix with chopsticks until the flour
        has absorbed the liquid.<br></br>
        Mix the dough bits together with your hands, then transfer to a working
        surface.<br></br>
        Knead for 3-4 minutes until a smooth and soft dough forms (but avoid
        overworking).<br></br>
        Finally, form the dough into two balls, wrap each tightly in cling film
        and refrigerate for one hour.<br></br>
        <br></br>
        <b>Filling:</b>
        <br></br>
        In the meantime, place the diced potatoes in a pot of salted water.{" "}
        <br></br>
        Drain and allow excess moisture to evaporate, then place in a bowl, and
        mash thoroughly with a potato masher or fork. <br></br>
        Bring to a boil and cook for about 10 minutes, or until fork-tender.{" "}
        <br></br>
        Set aside to cool completely.<br></br>
        <br></br>
        In a large pan, heat one tbsp of oil. Add the onions and sauté for 2-3
        minutes until lightly browned.
        <br></br>Add the garlic, ginger, curry powder, cumin, paprika powder,
        and turmeric.
        <br></br>Sauté for another 30 seconds to develop flavors. Set aside.
        <br></br>
        <br></br>
        Once the potatoes have cooled to room temperature, add in the onion
        mixture, chopped bell peppers, and thawed peas. <br></br>
        Sprinkle salt and pepper to taste, stir to combine, and set aside.
        <br></br>
        <br></br>
        <b>Fold samosas:</b>
        <br></br>
        After the chill time, remove one portion of the dough from the fridge.{" "}
        <br></br>
        Divide it into 8 pieces and form each piece into a ball. <br></br>
        Work with one small dough ball at a time and cover the rest with a damp
        cloth to prevent it from drying out.<br></br>
        <br></br>
        On a lightly floured work surface, roll out one small dough ball to a
        6-inch (15 cm) circle. Cut it in half to form two half-moon shapes.
        <br></br>
        Take approx. 2 tbsp of the filling and press it together into a triangle
        shape. <br></br>
        Then place it onto the half-moon dough shaped dough you just cut (see
        step-by-step photos above). <br></br>
        Brush the outer edges with water, then fold one side of the dough over
        and around the filling to create a triangle/cone shape. <br></br>
        Pinch the edges together, make sure your samosas are well sealed. Place
        on a wooden board (be sure to leave enough space between each samosa to
        prevent them from sticking together) while you prepare the rest.
        <br></br>
        When all balls are wrapped into samosas, remove the second portion of
        the dough from the refrigerator, and continue this process to make more
        samosas.<br></br>
        <br></br>
        <b>Cook samosas:</b>
        <br></br>
        Now you can fry or bake them. To fry, heat around 2 cups of oil in a
        deep pot or pan to 320-338°F (160-170°C). <br></br>
        Once hot, carefully drop the samosas and fry in batches until the
        samosas are golden-browned and crispy, turning occasionally (make sure
        not to overcrowd the pot.)<br></br>
        Remove from the pot and transfer them to a plate lined with paper towels
        (this will get rid of excess oil).<br></br>
        Finally, sprinkle the samosa with sesame seeds and serve with vegan
        raita, guacamole, or any dip of your choice. Enjoy!<br></br>
      </Typography>
    </Card>
  );
}
